import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledCard = styled.div`
  width: 100%;
  height: 100%;
  padding: ${({ noPadding }) => (noPadding ? "0" : "16px")};
  ${({ theme, noPadding }) => theme.media.tabletUp`
    padding: ${() => (noPadding ? "0" : "32px")};
  `};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  color: ${({ theme }) => theme.colors.gray1200};
  transition: ${({ theme }) => theme.motion.short};
  background-color: ${({ theme }) => theme.colors.white};
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
`;

const Card = ({ children, className, noPadding }) => {
  return (
    <StyledCard className={className} noPadding={noPadding}>
      {children}
    </StyledCard>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool
};

Card.defaultProps = {
  noPadding: false
};

export default Card;
